import { render, staticRenderFns } from "./EquipmentRefrigerator.vue?vue&type=template&id=2dd5a1bc&scoped=true"
import script from "./EquipmentRefrigerator.vue?vue&type=script&lang=ts"
export * from "./EquipmentRefrigerator.vue?vue&type=script&lang=ts"
import style0 from "./EquipmentRefrigerator.vue?vue&type=style&index=0&id=2dd5a1bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd5a1bc",
  null
  
)

export default component.exports